import * as actionTypes from '../actions/actionTypes';
import { updatedObj } from  '../../shared/Utility';

const initialState = {
	successMessage: null,
	errorMessage: null,
	loading: false,
	showSideNav: false
};

const contactInit = (state, action) =>  {
	return updatedObj(state, {
		errorMessage: null,
		successMessage: null,
		loading: true
	});
};
const contactSuccess = (state, action) =>  {
	return updatedObj(state, {
		loading: false,
		successMessage: action.successMessage
	});
};
const contactFail = (state, action) =>  {
	return updatedObj(state, {
		loading: false,
		errorMessage: action.errorMessage
	});
};
const toggleSideNav = (state, action) =>  {
	return updatedObj(state, {
		showSideNav: action.showSideNav
	});
};

const reducer = (state = initialState, action ) => {
	switch (action.type) {
		case actionTypes.CONTACT_FORM_INIT: return contactInit(state,action);
		case actionTypes.CONTACT_FORM_SUCCESS: return contactSuccess(state,action);
		case actionTypes.CONTACT_FORM_FAIL: return contactFail(state,action);
		case actionTypes.TOGGLE_SIDE_NAV: return toggleSideNav(state,action);
		default: return state;
	}
};

export default reducer;